import { render } from "./GroupOccupancyReport.vue?vue&type=template&id=78586502"
import script from "./GroupOccupancyReport.vue?vue&type=script&lang=js"
export * from "./GroupOccupancyReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__